import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { ITipoEmpleadoModel } from 'src/app/models/interfaces/tipo-empleado/ITipoEmpleadoModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { TipoEmpleadoModel } from 'src/app/models/tipo-empleado/TipoEmpleadoModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { TipoEmpleadoService } from 'src/app/services/tipo-empleado/tipo-empleado.service';

@Component({
  templateUrl: './configuracion-tipo-empleado-editar.component.html',
  styleUrls: ['./configuracion-tipo-empleado-editar.component.css']
})
export class ConfiguracionTipoEmpleadoEditarComponent implements OnInit {
  id: number = 0;
  model: ITipoEmpleadoModel = new TipoEmpleadoModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private serviceTipoEmpleado: TipoEmpleadoService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });

    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });

    this.serviceTipoEmpleado.getById(this.id).subscribe((data) => {
      this.model = data;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.serviceTipoEmpleado.update(this.model).subscribe((data) => {
            this.alertDialogService.open("El tipo de empleado fue actualizado");
            this.router.navigate(['/configuracion', 'tipo-empleados']);  
          });
        }
      });
    }
  }
}
